// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { nativeVerticalScrollStyles } from 'components/common/scroll/nativeScrollStyles';
import useContractKpiApi from './useContractKpiApi';
import KpiTile from './KpiTile';
import styled from 'styled-components';
import React from 'react';
import TestableLoader from 'components/treactui-template/atoms/TestableLoader';

export default function ContractsKpis() {
  const { contractKpi, isLoading } = useContractKpiApi();

  if (isLoading) return <TestableLoader label='' data-testid='settings-contracts-kpis-loader' />;

  if (!contractKpi || Object.keys(contractKpi).length === 0) return <></>;

  return (
    <ContractsKpiContainer>
      {contractKpi &&
        Object.entries(contractKpi).map(([materialNumber, data]) => (
          <KpiTile key={materialNumber} data={data} materialNumber={materialNumber} />
        ))}
    </ContractsKpiContainer>
  );
}

const ContractsKpiContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${nativeVerticalScrollStyles};
  gap: 1.25rem;
  padding: 0.625rem;
`;
